// This file is auto-generated

import { Message, BinaryWriter, BinaryReader } from "google-protobuf";

import * as dep_1 from "./contact";
import * as dep_2 from "./contact_package";
import * as dep_3 from "./package_file";
import * as dep_4 from "./../tolemac/pub/filter";

export enum AttendanceStatus {
    UNDEFINED_AttendanceStatus = 0,
    /**
     * default
     */
    DRAFT = 1,
    /**
     * waiting submission (cf: date of attendance)
     */
    DRAFT__WAITING = 6,
    /**
     * waiting an admin to validate or reject this submission
     */
    TO_BE_VALIDATED = 2,
    /**
     * rejected by an admin, the trainee must resubmit
     */
    REJECTED = 3,
    RECEIVED = 4,
    /**
     * old attendance whithout details
     */
    RECEIVED__ARCHIVED = 5,
}
export interface IAttendanceSubmit {
    id?: number;
    /**
     * RECEIVED or TO_BE_VALIDATED or REJECTED
     */
    status?: AttendanceStatus;
    comment?: string;

}
export class AttendanceSubmit implements IAttendanceSubmit {

    id?: number;
    status?: AttendanceStatus;
    comment?: string;

    constructor(data?: Partial<IAttendanceSubmit>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MAttendanceSubmit extends Message implements AttendanceSubmit {

    constructor(data?: Partial<IAttendanceSubmit>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("id" in data && data.id != undefined) this.id = data.id;
            if ("status" in data && data.status != undefined) this.status = data.status;
            if ("comment" in data && data.comment != undefined) this.comment = data.comment;
        }
    }

    get id(): number {
        return Message.getField(this, 1) as number;
    }
    set id(value: number) {
        Message.setField(this, 1, value);
    }

    get status(): AttendanceStatus {
        return Message.getField(this, 2) as AttendanceStatus;
    }
    set status(value: AttendanceStatus) {
        Message.setField(this, 2, value);
    }

    get comment(): string {
        return Message.getField(this, 3) as string;
    }
    set comment(value: string) {
        Message.setField(this, 3, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new AttendanceSubmit() : {} as AttendanceSubmit;
        if (this.id != undefined) data.id = this.id;
        if (this.status != undefined) data.status = this.status;
        if (this.comment != undefined) data.comment = this.comment;
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.id !== undefined) writer.writeInt32(1, this.id);
                if (this.status !== undefined) writer.writeEnum(2, this.status);
                if (this.comment !== undefined) writer.writeString(3, this.comment);
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IAttendanceSubmit): Uint8Array {
        return (data instanceof Message ? (data as MAttendanceSubmit) : new MAttendanceSubmit(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MAttendanceSubmit {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MAttendanceSubmit();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.id = reader.readInt32();
                    break;
            case 2:
                    message.status = reader.readEnum();
                    break;
            case 3:
                    message.comment = reader.readString();
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MAttendanceSubmit {
        return MAttendanceSubmit.deserializeBinaryFromReader(new MAttendanceSubmit(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MAttendanceSubmit, reader: BinaryReader) {
        return Object.assign(msg, MAttendanceSubmit.deserialize(reader))
    };

}
export interface IAttendance {
    id?: number;
    date?: number;
    year?: number;
    /**
     * 1..12
     */
    month?: number;
    /**
     * in minutes.
     */
    workDuration?: number;
    status?: AttendanceStatus;
    days?: IAttendanceDay[];
    /**
     * comment added on submission
     */
    comment?: string;
    updatedAt?: number;
    /**
     * @lazy
     */
    timespanPackage?: dep_3.ITimespanPackage;
    /**
     * @lazy
     */
    contact?: dep_1.IContact;
    /**
     * @lazy
     */
    contactPackage?: dep_2.IContactPackage;

}
export class Attendance implements IAttendance {

    id?: number;
    date?: number;
    year?: number;
    month?: number;
    workDuration?: number;
    status?: AttendanceStatus;
    days: AttendanceDay[];
    comment?: string;
    updatedAt?: number;
    timespanPackage?: dep_3.TimespanPackage;
    contact?: dep_1.Contact;
    contactPackage?: dep_2.ContactPackage;

    constructor(data?: Partial<IAttendance>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MAttendance extends Message implements Attendance {

    constructor(data?: Partial<IAttendance>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [8], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("id" in data && data.id != undefined) this.id = data.id;
            if ("date" in data && data.date != undefined) this.date = data.date;
            if ("year" in data && data.year != undefined) this.year = data.year;
            if ("month" in data && data.month != undefined) this.month = data.month;
            if ("workDuration" in data && data.workDuration != undefined) this.workDuration = data.workDuration;
            if ("status" in data && data.status != undefined) this.status = data.status;
            if ("days" in data && data.days != undefined) this.days = data.days.map(d => new MAttendanceDay(d));
            if ("comment" in data && data.comment != undefined) this.comment = data.comment;
            if ("updatedAt" in data && data.updatedAt != undefined) this.updatedAt = data.updatedAt;
            if ("timespanPackage" in data && data.timespanPackage != undefined) this.timespanPackage = new dep_3.MTimespanPackage(data.timespanPackage);
            if ("contact" in data && data.contact != undefined) this.contact = new dep_1.MContact(data.contact);
            if ("contactPackage" in data && data.contactPackage != undefined) this.contactPackage = new dep_2.MContactPackage(data.contactPackage);
        }
    }

    get id(): number {
        return Message.getField(this, 1) as number;
    }
    set id(value: number) {
        Message.setField(this, 1, value);
    }

    get date(): number {
        return Message.getField(this, 11) as number;
    }
    set date(value: number) {
        Message.setField(this, 11, value);
    }

    get year(): number {
        return Message.getField(this, 4) as number;
    }
    set year(value: number) {
        Message.setField(this, 4, value);
    }

    get month(): number {
        return Message.getField(this, 5) as number;
    }
    set month(value: number) {
        Message.setField(this, 5, value);
    }

    get workDuration(): number {
        return Message.getField(this, 6) as number;
    }
    set workDuration(value: number) {
        Message.setField(this, 6, value);
    }

    get status(): AttendanceStatus {
        return Message.getField(this, 7) as AttendanceStatus;
    }
    set status(value: AttendanceStatus) {
        Message.setField(this, 7, value);
    }

    get days(): MAttendanceDay[] {
        return Message.getRepeatedWrapperField(this, MAttendanceDay, 8);
    }
    set days(value: MAttendanceDay[]) {
        Message.setRepeatedWrapperField(this, 8, value);
    }

    get comment(): string {
        return Message.getField(this, 9) as string;
    }
    set comment(value: string) {
        Message.setField(this, 9, value);
    }

    get updatedAt(): number {
        return Message.getField(this, 10) as number;
    }
    set updatedAt(value: number) {
        Message.setField(this, 10, value);
    }

    get timespanPackage(): dep_3.MTimespanPackage {
        return Message.getWrapperField(this, dep_3.MTimespanPackage, 20);
    }
    set timespanPackage(value: dep_3.MTimespanPackage) {
        Message.setWrapperField(this, 20, value);
    }

    get contact(): dep_1.MContact {
        return Message.getWrapperField(this, dep_1.MContact, 21);
    }
    set contact(value: dep_1.MContact) {
        Message.setWrapperField(this, 21, value);
    }

    get contactPackage(): dep_2.MContactPackage {
        return Message.getWrapperField(this, dep_2.MContactPackage, 22);
    }
    set contactPackage(value: dep_2.MContactPackage) {
        Message.setWrapperField(this, 22, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new Attendance() : {} as Attendance;
        if (this.id != undefined) data.id = this.id;
        if (this.date != undefined) data.date = this.date;
        if (this.year != undefined) data.year = this.year;
        if (this.month != undefined) data.month = this.month;
        if (this.workDuration != undefined) data.workDuration = this.workDuration;
        if (this.status != undefined) data.status = this.status;
        data.days = this.days.map(d => d.toObject(includeInstance));
        if (this.comment != undefined) data.comment = this.comment;
        if (this.updatedAt != undefined) data.updatedAt = this.updatedAt;
        if (this.timespanPackage != undefined) data.timespanPackage = this.timespanPackage.toObject(includeInstance);
        if (this.contact != undefined) data.contact = this.contact.toObject(includeInstance);
        if (this.contactPackage != undefined) data.contactPackage = this.contactPackage.toObject(includeInstance);
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.id !== undefined) writer.writeInt32(1, this.id);
                if (this.date !== undefined) writer.writeInt64(11, this.date);
                if (this.year !== undefined) writer.writeInt32(4, this.year);
                if (this.month !== undefined) writer.writeInt32(5, this.month);
                if (this.workDuration !== undefined) writer.writeInt32(6, this.workDuration);
                if (this.status !== undefined) writer.writeEnum(7, this.status);
                if (this.days !== undefined) writer.writeRepeatedMessage(8, this.days, (i) => i.serialize(writer));
                if (this.comment !== undefined) writer.writeString(9, this.comment);
                if (this.updatedAt !== undefined) writer.writeInt64(10, this.updatedAt);
                if (this.timespanPackage !== undefined) writer.writeMessage(20, this.timespanPackage, () => this.timespanPackage.serialize(writer));
                if (this.contact !== undefined) writer.writeMessage(21, this.contact, () => this.contact.serialize(writer));
                if (this.contactPackage !== undefined) writer.writeMessage(22, this.contactPackage, () => this.contactPackage.serialize(writer));
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IAttendance): Uint8Array {
        return (data instanceof Message ? (data as MAttendance) : new MAttendance(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MAttendance {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MAttendance();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.id = reader.readInt32();
                    break;
            case 11:
                    message.date = reader.readInt64();
                    break;
            case 4:
                    message.year = reader.readInt32();
                    break;
            case 5:
                    message.month = reader.readInt32();
                    break;
            case 6:
                    message.workDuration = reader.readInt32();
                    break;
            case 7:
                    message.status = reader.readEnum();
                    break;
            case 8:
                    reader.readMessage(message.days, () => Message.addToRepeatedWrapperField(message, 8, MAttendanceDay.deserialize(reader), MAttendanceDay));
                    break;
            case 9:
                    message.comment = reader.readString();
                    break;
            case 10:
                    message.updatedAt = reader.readInt64();
                    break;
            case 20:
                    reader.readMessage(message.timespanPackage, () => message.timespanPackage = dep_3.MTimespanPackage.deserialize(reader));
                    break;
            case 21:
                    reader.readMessage(message.contact, () => message.contact = dep_1.MContact.deserialize(reader));
                    break;
            case 22:
                    reader.readMessage(message.contactPackage, () => message.contactPackage = dep_2.MContactPackage.deserialize(reader));
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MAttendance {
        return MAttendance.deserializeBinaryFromReader(new MAttendance(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MAttendance, reader: BinaryReader) {
        return Object.assign(msg, MAttendance.deserialize(reader))
    };

}
export interface IAttendanceDay {
    /**
     * 0...31
     */
    day?: number;
    /**
     * in minutes
     */
    amWorkDuration?: number;
    /**
     * in minutes
     */
    pmWorkDuration?: number;

}
export class AttendanceDay implements IAttendanceDay {

    day?: number;
    amWorkDuration?: number;
    pmWorkDuration?: number;

    constructor(data?: Partial<IAttendanceDay>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MAttendanceDay extends Message implements AttendanceDay {

    constructor(data?: Partial<IAttendanceDay>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("day" in data && data.day != undefined) this.day = data.day;
            if ("amWorkDuration" in data && data.amWorkDuration != undefined) this.amWorkDuration = data.amWorkDuration;
            if ("pmWorkDuration" in data && data.pmWorkDuration != undefined) this.pmWorkDuration = data.pmWorkDuration;
        }
    }

    get day(): number {
        return Message.getField(this, 1) as number;
    }
    set day(value: number) {
        Message.setField(this, 1, value);
    }

    get amWorkDuration(): number {
        return Message.getField(this, 2) as number;
    }
    set amWorkDuration(value: number) {
        Message.setField(this, 2, value);
    }

    get pmWorkDuration(): number {
        return Message.getField(this, 3) as number;
    }
    set pmWorkDuration(value: number) {
        Message.setField(this, 3, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new AttendanceDay() : {} as AttendanceDay;
        if (this.day != undefined) data.day = this.day;
        if (this.amWorkDuration != undefined) data.amWorkDuration = this.amWorkDuration;
        if (this.pmWorkDuration != undefined) data.pmWorkDuration = this.pmWorkDuration;
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.day !== undefined) writer.writeInt32(1, this.day);
                if (this.amWorkDuration !== undefined) writer.writeInt32(2, this.amWorkDuration);
                if (this.pmWorkDuration !== undefined) writer.writeInt32(3, this.pmWorkDuration);
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IAttendanceDay): Uint8Array {
        return (data instanceof Message ? (data as MAttendanceDay) : new MAttendanceDay(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MAttendanceDay {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MAttendanceDay();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.day = reader.readInt32();
                    break;
            case 2:
                    message.amWorkDuration = reader.readInt32();
                    break;
            case 3:
                    message.pmWorkDuration = reader.readInt32();
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MAttendanceDay {
        return MAttendanceDay.deserializeBinaryFromReader(new MAttendanceDay(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MAttendanceDay, reader: BinaryReader) {
        return Object.assign(msg, MAttendanceDay.deserialize(reader))
    };

}
export interface IAttendances {
    values?: IAttendance[];
    count?: number;

}
export class Attendances implements IAttendances {

    values: Attendance[];
    count?: number;

    constructor(data?: Partial<IAttendances>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MAttendances extends Message implements Attendances {

    constructor(data?: Partial<IAttendances>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("values" in data && data.values != undefined) this.values = data.values.map(d => new MAttendance(d));
            if ("count" in data && data.count != undefined) this.count = data.count;
        }
    }

    get values(): MAttendance[] {
        return Message.getRepeatedWrapperField(this, MAttendance, 1);
    }
    set values(value: MAttendance[]) {
        Message.setRepeatedWrapperField(this, 1, value);
    }

    get count(): number {
        return Message.getField(this, 2) as number;
    }
    set count(value: number) {
        Message.setField(this, 2, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new Attendances() : {} as Attendances;
        data.values = this.values.map(d => d.toObject(includeInstance));
        if (this.count != undefined) data.count = this.count;
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.values !== undefined) writer.writeRepeatedMessage(1, this.values, (i) => i.serialize(writer));
                if (this.count !== undefined) writer.writeInt32(2, this.count);
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IAttendances): Uint8Array {
        return (data instanceof Message ? (data as MAttendances) : new MAttendances(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MAttendances {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MAttendances();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    reader.readMessage(message.values, () => Message.addToRepeatedWrapperField(message, 1, MAttendance.deserialize(reader), MAttendance));
                    break;
            case 2:
                    message.count = reader.readInt32();
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MAttendances {
        return MAttendances.deserializeBinaryFromReader(new MAttendances(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MAttendances, reader: BinaryReader) {
        return Object.assign(msg, MAttendances.deserialize(reader))
    };

}
                        




export default () => {}